import { render, staticRenderFns } from "./ModalCompleteRegist.vue?vue&type=template&id=5a48c29f&scoped=true&"
import script from "./ModalCompleteRegist.vue?vue&type=script&lang=js&"
export * from "./ModalCompleteRegist.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompleteRegist.vue?vue&type=style&index=0&id=5a48c29f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48c29f",
  null
  
)

export default component.exports